import styled from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets';
import { Flex } from '../../../../components/Flex/Flex';
// import { Theme } from 'foundations-theming';
import { filterProps } from '../../../../utils/filterProps';
import { useIsDisplayOptimized } from '../../../context/DisplayOptimizedContext';
import { VENUS_LAYER } from '../../../constants';
import { useInputGroupContext } from '../../../components/InputGroup/InputGroupProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InputWrapper = styled.div.withConfig({
  displayName: "InputIconWrapper__InputWrapper",
  componentId: "sc-1wtrb9r-0"
})(({
  size,
  theme,
  $cssStyles,
  $isDisplayOptimized
}) => {
  return Object.assign({
    position: 'relative',
    '&& input': {
      paddingLeft: $isDisplayOptimized ? theme.space['500'] : `${20 + (size || 0)}px` // Provide a fallback if size is undefined
    }
  }, $cssStyles);
});
export const InputIconWrapper = props => {
  const {
    domProps
  } = filterProps(props);
  const isDisplayOptimized = useIsDisplayOptimized();
  // const theme = useTheme();
  const inputGroupContext = useInputGroupContext();
  const isInInputGroup = !!inputGroupContext;
  const {
    children,
    size,
    icon: Icon,
    disabled,
    $cssStyles,
    onFocus
  } = props;
  const iconPixelSize = useIconSize(size) || '16px';
  const computedNumberSize = parseInt(iconPixelSize.replace('px', ''), 10);
  return /*#__PURE__*/_jsxs(InputWrapper, Object.assign({}, domProps, {
    $cssStyles: $cssStyles,
    $isDisplayOptimized: isDisplayOptimized,
    size: computedNumberSize,
    onFocus: onFocus,
    children: [children, /*#__PURE__*/_jsx(Flex, {
      position: "absolute",
      insetBlockEnd: "0",
      insetBlockStart: "0",
      insetInlineStart: "0",
      paddingInline: isDisplayOptimized ? '0' : '250',
      alignItems: "center",
      zIndex: isInInputGroup ? VENUS_LAYER : undefined,
      children: /*#__PURE__*/_jsx(Icon, {
        color: disabled ? 'text-core-disabled' : 'inherit',
        size: size
      })
    })]
  }));
};